import api from '../services/api';
import { IGuideStatus } from '../shared/interfaces';

interface IResponseGetGuideStatus {
  data: IGuideStatus[];
  count: number;
}
export const getGuidesStatus = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetGuideStatus> => {
  const response = await api.post('/guides-status/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postGuideStatus = async (payload: any): Promise<IGuideStatus> => {
  const response = await api.post(`/guides-status`, payload);
  return response.data;
};

export const patchGuideStatus = async (
  id: string | undefined,
  payload: any,
): Promise<IGuideStatus> => {
  if (!id) {
    throw new Error('ID da guia não fornecido.');
  }
  const response = await api.patch(`/guides-status/${id}`, payload);
  return response.data;
};

export const getSelectGuidesStatus = async (): Promise<IGuideStatus[]> => {
  const response = await api.get(`/guides-status/select/all`);
  return response.data;
};
